module.exports = __webpack_public_path__ + "static/img/wizard.520d2d06.svg";